module.exports = __webpack_public_path__ + "static/media/patent_us.8849f87c.96f0cf0c.jpg";